import { render, staticRenderFns } from "./shiYong.vue?vue&type=template&id=99cdbd5a&scoped=true&"
import script from "./shiYong.vue?vue&type=script&lang=js&"
export * from "./shiYong.vue?vue&type=script&lang=js&"
import style0 from "./shiYong.vue?vue&type=style&index=0&id=99cdbd5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cdbd5a",
  null
  
)

export default component.exports